import { h } from '@atomify/jsx';
import { elements } from '@source/utilities/dom';

const initialiseAlert = async () => {
    const alertElementExists = !!document.querySelector('bpd-alert');

    if (!alertElementExists) {
        await import('@atoms/alert');

        elements.body.append(<bpd-alert />);
    }
};

export { initialiseAlert };
